<template>
<v-layout class="fill-height">
        <v-snackbar
            v-model="snackbar"
            :color="color"
            right
            top
            multi-line
            app
        >
            {{snackbarText}}
            <v-btn
            text
            dark
            @click="snackbar = false"
            >
            Fermer
            </v-btn>
        </v-snackbar>
    <v-navigation-drawer
      class="second-sidebar"
      width="fit-content"
      floating
      v-model="drawer"
      :class="drawer ? false : 'no-width'"
    >
      <v-item>
        <v-text-field
          placeholder="Rechercher.."
          class="search-form"
          prepend-icon="mdi-magnify"
          v-model="search"
          flat
          dense
          solo
        ></v-text-field>
      </v-item>
      <v-dialog v-model="newCustomerDialog" max-width="600px" v-if="newCustomerDialog">
        <new-customer v-on:closeNewCustomer="closeNewCustomer" v-on:reloadData="reloadData"></new-customer>
      </v-dialog>
      <v-dialog v-model="magasinageSingleDialog" v-if="magasinageSingleDialog">
        <single-facture-magasinage :currentAvis="null" :factureContent="factureContent" v-on:reloadData="reloadData" v-on:closeSingleFactureDialogMethod="closeSingleFactureMagasinageDialogMethod" @hide="magasinageSingleDialog = false"></single-facture-magasinage>
      </v-dialog>
      <v-dialog v-model="singleFactureDialog" v-if="singleFactureDialog">
        <single-standard-facture :factureContent="factureContent" v-on:reloadData="reloadData" v-on:hideDialog="closeSingleFactureDialogMethod" @hide="singleFactureDialog = false"></single-standard-facture>
      </v-dialog>

      <v-dialog v-model="singleSurestarie" v-if="singleSurestarie">
        <single-facture-surestarie :factureContent="factureContent" v-on:reloadData="reloadData" @hide="singleSurestarie = false"></single-facture-surestarie>
      </v-dialog>
      <v-dialog v-model="printOpsD" fullscreen v-if="printOpsD">
        <print-ops :operations="opsToPrint" :avisList="currentAvis" :dossierList="dossierList" :currentClientData="currentClientData" :period_ops="{period: period_ops, from: date_from, to: date_to}" v-on:reloadData="reloadData" @hide="printOpsD = false"></print-ops>
      </v-dialog>

      <v-toolbar dense flat>
        <!--<v-toolbar-title>{{ $vuetify.lang.t('$vuetify.select_business') }}</v-toolbar-title>-->
        <v-toolbar-title><b>Liste Clients</b></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-item>
          <v-btn class="add-btn mr-1" @click="newCustomerDialog = true" dark icon>
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-item>
      </v-toolbar>
      <v-list
        two-line
        three-line
        rounded
        max-width="350px"
      >
        <!--<v-subheader>2020</v-subheader>-->
        <v-list-item-group color="primary" v-model="currentClient" mandatory>
          <v-list-item value="0" style="display:none;"></v-list-item>
          <v-list-item
            v-for="(client, i) in filteredCustomers"
            :key="i"
            :value="client.id"
            @click="setCurrentClient(client.id)"
            :ripple="false"
          >
            <v-list-item-content>
              <v-list-item-title v-html="client.fullname"></v-list-item-title>
              <v-list-item-subtitle v-html="client.adresse"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
      <v-btn icon
        absolute
        class="toggle-second-sidebar"
        @click.stop="drawer = !drawer"
      >
        <v-icon v-if="drawer">mdi-chevron-left</v-icon>
        <v-icon v-if="!drawer" class="toggle-icon">mdi-chevron-right</v-icon>
      </v-btn>
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
          <v-card class="table-content" v-if="currentClient !== '0' && translaction === true">
            <v-card-title>
              <v-btn @click="translaction = false" icon><v-icon>mdi-chevron-left</v-icon></v-btn>
              Opérations relatives à {{currentClientData.fullname}} Ref#{{currentClientData.code_client}} 
              <v-spacer></v-spacer>
              <v-btn @click="translaction = false" text>Retour</v-btn>
              <v-btn color="primary" @click="printOpsM" fab><v-icon>mdi-printer</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col md="6" class="text-left">Nom Prénom: {{currentClientData.fullname}} </v-col>
                
                <v-col md="6" class="text-left">Matricule Fiscale: {{currentClientData.mf}}</v-col>
                <v-col md="6" class="text-left">Adresse: {{currentClientData.adresse}} - {{currentClientData.region}} {{currentClientData.code_postal}}</v-col>
                <v-col md="6" class="text-left">Téléphone: {{currentClientData.tel}} </v-col>
              </v-row>
              <v-data-table
                :headers="headersOperations"
                :items="filteredOps"
                dense
                :items-per-page="999"
                sort-by="date"
                hide-default-footer
                :sort-desc="true"
                class="elevation-0"
                @current-items="currentOps"
                
              >
                <template v-slot:[`item.date`]="{ item }">
                  {{ item.date | formatDate }}
                </template>
                <template v-slot:[`item.debit`]="{ item }">
                  {{ item.debit.toFixed(3) }}
                </template>
                <template v-slot:[`item.credit`]="{ item }">
                  {{ item.credit.toFixed(3) }}
                </template>
                <template v-slot:[`item.avis_id`]="{ item }">
                  <template v-if="item.avis_id > 0">
                  Dossier {{ currentAvis.filter(obj => {
                    return obj.id === item.avis_id
                  })[0].dossier.num_dossier }} - Avis {{ currentAvis.filter(obj => {
                    return obj.id === item.avis_id
                  })[0].num_avis }}
                  </template>
                  <template v-else-if="item.dossier_id > 0">
                    Dossier N°{{dossierList.filter(obj => {
                      return obj.id === item.dossier_id
                    })[0].numdossier }}
                  </template>
                  <template v-else>
                    -
                  </template>
                </template>
                <template v-slot:[`item.details`]="{ item }">
                  {{ item.libelle }} N°{{ item.num_facture }}
                </template>
                <template v-slot:[`top`]>
                  <tr>
                    <td colspan="6">
                      <v-select
                        style="width:250px;"
                        hide-details
                        class="pb-5"
                        v-model="period_ops"
                        :items="['Dernier Mois', 'Derniers 3 Mois', 'Derniers 6 Mois', 'Toujours']"
                        label="Période"
                      ></v-select>
                      
                    </td>
                    <td><div class="pl-5">Du <span v-if="date_from === null"> - </span> <span v-else>{{date_from | formatDate}}</span></div></td>
                    <td><div class="pl-5"><span>à {{date_to | formatDate}}</span></div></td>
                  </tr>
                </template>
                <template slot="body.append">
                      <tr>
                          <td colspan="3" style="font-weight:700;" class="text-right">Total</td>
                          <td style="font-weight:700;"  class="text-right">{{debit.toFixed(3)}}</td>
                          <td style="font-weight:700;" class="text-right">{{credit.toFixed(3)}}</td>
                      </tr>
                </template>
                <template slot="body.append">
                      <tr>
                          <td style="font-weight:700;" colspan="3" class="text-right">Solde</td>
                          <td style="font-weight:700;" class="text-right" colspan="2">{{Number(debit - credit).toFixed(3)}}</td>
                      </tr>
                </template>
              </v-data-table>
            </v-card-text>

          </v-card>
          <v-card class="table-content" v-else-if="currentClient !== '0'">
            <v-card-title>
              Fiche Client Ref#{{currentClientData.code_client}} 
              <v-spacer></v-spacer>
              <h5>Solde : {{ Number(solde).toFixed(3) }} TND</h5>
            </v-card-title>
            <v-row class="text-left">
                <v-col cols="12" md="4">
                    <v-list-item>
                        <h4>Informations Générales</h4>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Nom Complet</v-list-item-subtitle>
                            <v-list-item-title>{{currentClientData.fullname}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Date d'ajout</v-list-item-subtitle>
                            <v-list-item-title>{{currentClientData.date_ajout | formatDate}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Adresse Email</v-list-item-subtitle>
                            <v-list-item-title>{{currentClientData.email}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Profession</v-list-item-subtitle>
                            <v-list-item-title>{{currentClientData.profession}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line v-if="currentClientData.mf">
                        <v-list-item-content>
                            <v-list-item-subtitle>Matricule Fiscale</v-list-item-subtitle>
                            <v-list-item-title>{{currentClientData.mf}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>N°Téléphone</v-list-item-subtitle>
                            <v-list-item-title>{{currentClientData.tel}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Adresse</v-list-item-subtitle>
                            <v-list-item-title>{{currentClientData.adresse}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-subtitle>Région</v-list-item-subtitle>
                            <v-list-item-title>{{currentClientData.region}} {{currentClientData.code_postal}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    
                </v-col>
                <v-col cols="12" md="8">
                    <v-list-item>
                        <h4>Avis relatifs</h4>
                    </v-list-item>
                    <v-simple-table dense>
                        <template v-slot:default>
                        <tbody v-if="currentAvis.length > 0">
                            <tr v-for="(avis,index) in currentAvis" v-bind:key="index">
                            <td><v-btn :ripple="false" text>Avis N°{{avis.num_avis}}<span v-if="avis.facture.length > 0">(Facturé)</span></v-btn></td>
                            <td v-if="avis.montantTotal >= 0">Total : {{avis.montantTotal.toFixed(3)}} TND</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-center">Aucun avis trouvé relatif à ce client</td>
                          </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                    <v-list-item>
                        <h4>Factures relatifs</h4> 
                        <v-progress-circular
                          indeterminate
                          color="primary"
                          style="margin-left:10px;"
                          v-if="loader"
                          :width="2"
                          :size="15"
                        ></v-progress-circular>
                    </v-list-item>
                    <v-simple-table dense>
                        <template v-slot:default>
                        <tbody v-if="currentFacture.length > 0">
                            <tr v-for="(facture,index) in currentFacture" v-bind:key="index">
                            <td><v-btn :ripple="false" @click="openFacture(facture)" text>Facture N°{{facture.num_facture}} <span v-if="facture.solded == 0"> (Soldé)</span></v-btn></td>
                            <td><span v-if="facture.solded !== 0">Reste à Payer: {{facture.solded.toFixed(3)}} TND</span></td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td class="text-center">Aucune facture trouvée relative à ce client</td>
                          </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="openTranslaction">Toutes les opérations</v-btn>
                <v-btn color="primary"  :disabled="!permissions.includes('edit_client')">Editer</v-btn>
                <v-btn color="error" :disabled="!permissions.includes('delete_client')" @click="deleteUser(currentClientData.id)">Supprimer</v-btn>
            </v-card-actions>
          </v-card>
          <v-card class="table-content" v-else>
            <v-alert
              :value="true"
              color="primary"
              icon="mdi-alert-circle-outline"
              dark
              class="white--text"
            >
              Vous devez sélectionner un client pour afficher sa fiche.
            </v-alert>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>

<script>
import headerSidebar from '../commons/header_sidebar.component'
import newCustomer from './add'
import singleStandardFacture from '../dossier/facture/standard/single.component'
import singleFactureMagasinage from '../dossier/facture/magasinage/single.component'
import singleFactureSurestarie from '../dossier/facture/surestarie/single.component'
import printOps from './print'

export default {
  name: 'listingCustomer',
  props: ['permissions'],
  components: {headerSidebar, newCustomer, singleStandardFacture, singleFactureMagasinage, singleFactureSurestarie, printOps},
  data: () => ({
    drawer: true,
    business: 5,
    filterSelectbox: ['Tous','Import', 'Export'],
    dossierList: [],
    mini: false,
    search: '',
    expanded: [],
    drawerClass: '',
    newCustomerDialog: false,
    currentClient: 0,
    dialog: false,
    clientList: [],
    currentClientData: {},
    factureContent: {},
    loader: false,
    solde: 0,
    magasinageSingleDialog: false,
    currentAvis:[],
    singleFactureDialog: false,
    currentFacture:[],
    snackbar: false,
    snackbarText: '',
    headersOperations: [
      {
        text: 'Date',
        align: 'start',
        sortable: true,
        value: 'date',
      },
      { text: 'Dossier Relatif', value: 'avis_id', sortable: false },
      { text: 'Détails', value: 'details', sortable: false },/*
      { text: 'N°Avis', value: 'avis_id', sortable: false },
      { text: 'N°Facture', value: 'num_facture', sortable: false },
      { text: 'Libelle', value: 'libelle', groupable:false , sortable: false},*/
      { text: 'Débit (TND)', value: 'debit', groupable:false , sortable: false, align: 'right'},
      { text: 'Crédit (TND)', value: 'credit', groupable:false, sortable: false, align: 'right' },
    ],
    operations: [
      /*{date: '12/07/2020', num_facture: 20200047, avis_id:450, libelle: 'Facture Surestarie', debit: 378.254, credit: 0.000 },
      {date: '-', num_facture: 20200047,  avis_id:450, libelle: 'Règlement - Facture Surestarie', debit: 0.000, credit: 378.254},*/
    ],
    color: "success",
    translaction: false,
    singleSurestarie: false,
    period_ops: 'Toujours',
    date_from: null,
    printOpsD: false,
    date_to: new Date(),
    opsToPrint: [],
    credit: 0,
    debit: 0,
  }),
  mounted() {
    this.axios
    .get('/client/listing')
    .then(response => (this.clientList = response.data))

    this.axios
    .get('/dossier/listing')
    .then(response => (this.dossierList = response.data))
  },
  watch: {
    period_ops: function(){
      let dt = new Date()
      if(this.period_ops === 'Toujours'){
        this.date_from = null 
      }else if(this.period_ops === 'Derniers 6 Mois'){
        dt.setDate( dt.getDate() - 180 )
        this.date_from = dt
      }else if(this.period_ops === 'Derniers 3 Mois'){
        dt.setDate( dt.getDate() - 90 )
        this.date_from = dt
      }else if(this.period_ops === 'Dernier Mois'){
        dt.setDate( dt.getDate() - 30 )
        this.date_from = dt
      }
      //this.calculate()
    },
    opsToPrint: function(){
      this.calculate()
    }
  },
  computed: {
    filteredCustomers: function()
    {
    	 var self=this;
       return this.clientList.filter(function(cust){return cust.fullname.toLowerCase().indexOf(self.search.toLowerCase())>=0 || cust.email.toLowerCase().indexOf(self.search.toLowerCase())>=0 || cust.region.toLowerCase().indexOf(self.search.toLowerCase())>=0 ;});
    },
    filteredOps: function()
    {
      //this.calculate()
      var self=this
      return this.operations.filter(function(op){ return new Date(op.date) >= new Date(self.date_from) && new Date(op.date) <= new Date(self.date_to) })
    }
  },
  methods: {
    reloadData(){
      this.axios
        .get('/client/listing')
        .then(response => (this.clientList = response.data))
      this.setCurrentClient(this.currentClient)
    },
    openFacture(facture){
      this.factureContent = facture
      if(facture.is_magasinage !== 0){
        this.magasinageSingleDialog = true
      }else if(facture.is_surestarie !== 0){
        this.singleSurestarie = true
      }else{
        this.singleFactureDialog = true
      }
    },
    calculate(){
      this.credit = 0
      this.debit = 0
      //console.log(this.opsToPrint)
      this.opsToPrint.forEach((item, k) => {
        this.credit = this.credit + item.credit
        this.debit = this.debit + item.debit
      })
    },
    setFactureList(avis_list){
      this.currentFacture = []
      if(this.currentClientData.facture.length > 0){
        this.currentClientData.facture.forEach((facture, key) => {
          this.axios
            .get('/facture/single/'+facture.id)
            .then(res => {
              //console.log(res.data)
              if(res.data.avis_id === 0 || res.data.is_magasinage === 1 || res.data.is_surestarie === 1 || res.data.is_da === 1){
                res.data.montantTotal = 0
                if(res.data.prestations.length > 0){
                  let prestations = res.data.prestations
                  this.solde = this.solde + this.calcul_prest(prestations, res.data.timbre)
                  res.data.montantTotal = res.data.montantTotal + this.calcul_prest(prestations, res.data.timbre)
                  /*.forEach((prest, k) => {
                    this.solde = this.solde +  Number(Number( Number(Number(prest.montant)) + Number( (Number(prest.montant).toFixed(3) * Number(Number(Number(prest.tva) / 100 ))) )).toFixed(3))
                    res.data.montantTotal = res.data.montantTotal + Number(Number( Number(Number(prest.montant)) + Number( (Number(prest.montant).toFixed(3) * Number(Number(Number(prest.tva) / 100 ))) )).toFixed(3))
                  })
                  this.solde = this.solde + 0.6
                  res.data.montantTotal = res.data.montantTotal+0.6*/
                }
                
              }else{
                res.data.montantTotal = avis_list.filter(obj => {
                  return obj.id === res.data.avis_id
                })[0].montantTotal
              }
              /*else{
                //console.log(res.data.montantTotal = this.currentAvis.filter(obj => {
                  return obj.id === res.data.avis_id
                }))
              }*/
              
              res.data.solded = res.data.montantTotal
              res.data.reglement.forEach((reglement, index) => {
                this.solde = this.solde - Number(reglement.montant.toFixed(3))
                res.data.solded = Number(res.data.solded.toFixed(3)) - Number(reglement.montant.toFixed(3))
                ////console.log(res.data.solded)
              })
              this.currentFacture.push(res.data)
            })
        })
      }
    },
    closeNewCustomer(res){
      if(res > 0){
        this.currentClient = 0
        this.color = "success"
        this.snackbarText = "Le client a été ajouté avec succès."
        this.snackbar = true
      }
      this.newCustomerDialog = false
    },
    openTranslaction(){
      this.operations = []
      this.currentFacture.forEach((item, key) => {
        let data = {
          num_facture: item.num_facture,
          date: item.date,
          libelle: item.libelle,
          credit: 0,
          debit: item.montantTotal,
          avis_id: item.avis_id,
          dossier_id: item.dossier_id
        }
        this.operations.push(data)
        if(item.reglement.length > 0){
          item.reglement.forEach((reg, k) => {
            data = {
              libelle: '*Règlement '+reg.mode+' '+reg.banque+' '+reg.num_piece+' Par '+reg.client+' Facture',
              num_facture: item.num_facture,
              credit: reg.montant,
              debit: 0,
              avis_id: item.avis_id,
              dossier_id: item.dossier_id,
              date: item.date,
            }
            this.operations.push(data)
          })
          
        }
      })
      this.opsToPrint = this.operations
      this.drawer = false
      this.translaction = true
    },
    closeSingleFactureMagasinageDialogMethod (){
      this.magasinageSingleDialog = false
    },
    closeSingleFactureDialogMethod (){
      this.singleFactureDialog = false
    },
    async setCurrentClient(id){
      this.solde = 0;
      this.currentClientData = {}
      this.loader = []
      this.translaction = false
      let arr = []
      this.axios
      .get('/client/single/'+id)
      .then(client => {
        this.currentClientData = client.data
        this.currentAvis = []
        //console.log(client.data)
        if(client.data){
          client.data.avis.forEach((item, index) => {
            this.axios
              .get('/avis/single/'+item.id)
              .then(response => {
                response.data.montantTotal = 0
                if(response.data.prestations.length > 0 ){
                  let prestations = response.data.prestations
                  this.solde = this.solde + this.calcul_prest(prestations, response.data.timbre)
                  response.data.montantTotal = response.data.montantTotal + this.calcul_prest(prestations, response.data.timbre)
                  /*
                  response.data.prestations.forEach((prest, key) => {
                    this.solde = Number(this.solde) + Number(Number( Number(Number(prest.montant.toFixed(3))) + Number( (Number(prest.montant) * Number(Number(Number(prest.tva) / 100 ))) )).toFixed(3))
                    response.data.montantTotal = response.data.montantTotal + Number(Number( Number(Number(prest.montant.toFixed(3))) + Number( (Number(prest.montant) * Number(Number(Number(prest.tva) / 100 ))) )).toFixed(3))
                  })
                  this.solde = Number(this.solde) + 0.6
                  response.data.montantTotal = response.data.montantTotal + 0.6*/
                }else{
                  response.data.montantTotal = 0
                }
                arr.push(response.data)
                this.currentAvis.push(response.data)

              })
            
          })
        }
        
        //arr = JSON.parse(JSON.stringify(arr))
        var self = this
        this.currentFacture = []
        setTimeout(function(){
          //console.log(arr[0])
          self.setFactureList(arr)
          self.loader = false
        }, 500)
        
        
      })

      
    },
    currentOps: function(value){
      this.opsToPrint = value
    },
    printOpsM(){
      this.printOpsD = true

      ////console.log(this.opsToPrint)
    },
    calcul_prest(prests, timbre = 1){
        let totalnt = 0
        let totalt = 0
        let totaltva = 0
        let total = 0
        prests.forEach((item , index) => {
            item.cour = Number(item.cour)
            item.montant = Number(item.montant)
            item.montantDevise = Number(item.montantDevise)
            item.tva = Number(item.tva)
            item.montantTva = Number(item.montant.toFixed(3)) * item.tva / 100
            if(item.cour > 0){
                prests[index].montant = item.cour * item.montantDevise
            } 
            if(item.tva === 0){
                totalnt = item.montant + totalnt
            }else{
                totaltva = item.montant * item.tva / 100  + totaltva
                totalt = item.montant + totalt
            }
        })
        total =  Number(total.toFixed(3)) + Number(totalnt.toFixed(3)) + Number(totalt.toFixed(3)) + Number(totaltva.toFixed(3)) + Number(timbre.toFixed(3))
      return total
    },
    deleteUser(id){
        if(confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?')){
          this.axios
            .delete('/client/delete/'+id)
            .then(res => {
              if(res.data === 'error'){
                this.color = "error"
                this.snackbarText = "Un erreur est survenu, essayez plus tard."
                this.snackbar = true
              }else{
                this.color = "success"
                this.snackbarText = "Le client a été supprimé avec succès."
                this.snackbar = true
              }
              this.currentClient = 0
              this.reloadData()
            }).catch(e => {
              this.color = "error"
              this.snackbar = true
              this.snackbarText = "Un erreur est survenu, essayez plus tard."
              //console.log(e)
            })

        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .no-client {
    background: #e5eff9;
    height: 60vh;
    border: dashed 3px #207ddd;
    border-radius: 25px;
    line-height: 60vh;
    font-size: 32px;
    color: #207ddd;
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-toolbar {
    background: transparent !important;
    .back-dashboard {
      font-size: 12px;
      color: #9ca8b4;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 700;
      .v-icon {
        font-size: 14px;
      }
    }
    .right-btn-group .v-btn {
      margin-left:10px;
      box-shadow: 0px 1px 0px rgba(0,0,0,0.1);
      background: white !important;
      padding: 20px 10px;
      text-transform: none;
      letter-spacing: 0.01em;
      color: #46545c;
      font-size: 12px;
      font-weight: 700;
      &.success {
        background: #70cd0d !important;
        color: white;
      }
      span {
        max-width: 175px;
      }
    }
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/customer/listing.vue